import React, { forwardRef } from "react";

import styles from "./Checkbox.module.css";

export const Checkbox = forwardRef(
  ({ handleChange, checked, disabled, onChange, className = "", ...rest }, ref) => {
    const handleInputChange = (e) => {
      handleChange?.(e);
      onChange?.(e);
    };

    return (
      <div className={`${styles.checkboxWrapper} ${className}`.trim()}>
        <input
          className={styles.checkbox}
          type="checkbox"
          checked={checked ?? undefined}
          onChange={handleInputChange}
          disabled={disabled}
          ref={ref}
          {...rest}
        />
        <span className={styles.customCheckbox} aria-hidden="true" />
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox";
